import {
  ActionFromReducersMapObject,
  StateFromReducersMapObject,
  combineReducers,
} from '@reduxjs/toolkit';
import { Reducer } from 'redux';
import { connectRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import authSlice from './auth-slice';
import orgSlice from './org-slice';
import dashboardSlice from './dashboard-slice';
import realtimeSlice from './realtime-slice';
import tourSlice from './tour-slice';
import conversationSlice from './conversation-slice';
import chatSlice from './chat-slice';
import feedSlice from './feed-slice';
import journeySlice from './journey-slice';
import appNotificationSlice from './app-notification-slice';
import aiVoiceSlice from './ai-voice-slice';
import outboundSlice from 'shared/store/outbound-slice';
import salesfloorSlice from 'shared/store/salesfloor-slice';
import schedulerSlice from 'shared/store/scheduler-slice';
import uiConfigSlice from 'shared/store/ui-config-slice';
import { orgSchedulerApi } from 'shared/store/schedulerApi';
import designerSlice from 'shared/store/designer-slice';
import livelistenSlice from './livelisten-slice';
import transcriptionSlice from './transcription-slice';
import aiChatSlice from './ai-chat-slice';
import aiInboundSlice from './ai-inbound-slice';
import schedulingSlice from './scheduling-slice';
import globalInboxSlice from './global-inbox-slice';
import goalSlice from './goal-slice';
import repOnboardingSlice from './rep-onboarding-slice';

export const history = createBrowserHistory();

const reducers = {
  router: connectRouter(history),
  auth: authSlice,
  org: orgSlice,
  dashboard: dashboardSlice,
  designer: designerSlice,
  realtime: realtimeSlice,
  tour: tourSlice,
  conversation: conversationSlice,
  chat: chatSlice,
  feed: feedSlice,
  journey: journeySlice,
  appNotification: appNotificationSlice,
  aiVoice: aiVoiceSlice,
  outbound: outboundSlice,
  salesfloor: salesfloorSlice,
  scheduler: schedulerSlice,
  uiConfig: uiConfigSlice,
  livelisten: livelistenSlice,
  transcription: transcriptionSlice,
  aiChat: aiChatSlice,
  aiInbound: aiInboundSlice,
  scheduling: schedulingSlice,
  globalInbox: globalInboxSlice,
  goal: goalSlice,
  repOnboarding: repOnboardingSlice,
  [orgSchedulerApi.reducerPath]: orgSchedulerApi.reducer,
};

// This is a workaround for a bug in the types for combineReducers
// for more information checkout https://github.com/reduxjs/redux-toolkit/issues/2068
// should be resolved in @reduxjs/toolkit v2.0.0
export type ReducersMapObject = typeof reducers;
const rootReducer: Reducer<
  StateFromReducersMapObject<ReducersMapObject>,
  ActionFromReducersMapObject<ReducersMapObject>
> = combineReducers(reducers);

export const additionalMiddleware = [orgSchedulerApi.middleware];

export type AppState = ReturnType<typeof rootReducer>;

export default rootReducer;
